import { useState } from "react";
import { createContext } from "react";

export const EnvContext = createContext();

const EnvProvider = ({ children }) => {
  const [showLoader, setShowLoader] = useState(false);
  return (
    <EnvContext.Provider
      value={{
        showLoader: [showLoader, setShowLoader],
      }}
    >
      {children}
    </EnvContext.Provider>
  );
};

export default EnvProvider;
